/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  FundTenantGuaranteeOptions,
  FundTenantGuaranteeStatus200,
  FundTenantGuaranteeStatus400,
  FundTenantGuaranteeStatus500,
} from '../types/FundTenantGuarantee'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { fundTenantGuarantee } from '../clients/fundTenantGuarantee'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const fundTenantGuaranteeMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/fund_guarantee' }] as const

export function fundTenantGuaranteeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = fundTenantGuaranteeMutationKey()
  return mutationOptions<
    FundTenantGuaranteeStatus200,
    ResponseErrorConfig<FundTenantGuaranteeStatus400 | FundTenantGuaranteeStatus500>,
    FundTenantGuaranteeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return fundTenantGuarantee({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Creates a guarantee-fund ledger entry with tx_kind DEPOSIT.
 * @summary Add funds to the guarantee fund for a tenant.
 * {@link /v1/tenants/:tenant_id/fund_guarantee}
 */
export function useFundTenantGuarantee<TContext>(
  options: {
    mutation?: UseMutationOptions<
      FundTenantGuaranteeStatus200,
      ResponseErrorConfig<FundTenantGuaranteeStatus400 | FundTenantGuaranteeStatus500>,
      FundTenantGuaranteeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? fundTenantGuaranteeMutationKey()

  const baseOptions = fundTenantGuaranteeMutationOptions(config) as UseMutationOptions<
    FundTenantGuaranteeStatus200,
    ResponseErrorConfig<FundTenantGuaranteeStatus400 | FundTenantGuaranteeStatus500>,
    FundTenantGuaranteeOptions,
    TContext
  >

  return useMutation<
    FundTenantGuaranteeStatus200,
    ResponseErrorConfig<FundTenantGuaranteeStatus400 | FundTenantGuaranteeStatus500>,
    FundTenantGuaranteeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    FundTenantGuaranteeStatus200,
    ResponseErrorConfig<FundTenantGuaranteeStatus400 | FundTenantGuaranteeStatus500>,
    FundTenantGuaranteeOptions,
    TContext
  >
}
